import React, { useEffect, useState } from 'react'
import DynamicTable from '../../components/DynamicTable'
import CssBaseline from '@material-ui/core/CssBaseline'
import { API } from 'aws-amplify';
import DForm from '../../components/DForm';
import ConfirmationModal from '../../components/ConfirmationModal';
import useUIState from '../../hooks/useUIstate';
import { promotionsFormToReqBody } from './PromotionsController';
import { Promotion } from '../../interfaces/IPromotions';
import { s3put, s3remove, getZeroOnEmpty } from '../../helpers/commonFunctions';
import PromotionTranslationModal from '../../components/PromotionTranslationModal';
import { useTranslation } from 'react-i18next';

function PromotionsCartTable(props) {
    const { setShowLoadingModal, setToastMessage, setShowToastMessage, setToastType } = useUIState();

    const [data, setData]: [any[], any] = useState([]);
    const [filteredData, setFilteredData]: [any[], any] = useState([]);
    const [ShowFilteredData, setShowFilteredData] = useState(false);
    const [showForm, setShowForm]: [boolean, any] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal]: [boolean, any] = useState(false);
    const [formValues, setFormValues]: [any, any] = useState({});
    const [activeRow, setActiveRow]: [any, any] = useState(null);
    const [formMode, setFormMode]: [string, any] = useState("");
    const [formObj, setFormObj]: [Record<string, any>[], any] = useState([]);
    const [UserConfigData, setUserConfigData]: [any, any] = useState([]);
    const [PromotionTypeOptions, setPromotionTypeOptions]: [any, any] = useState([]);
    const [showTranslationModal, setShowTranslationModal]: [boolean, any] = useState(false);
    const [translationFormModel, setTranslationFormModel]: [any, any] = useState({});
    const [translationFormFieldsModel, setTranslationFormFieldsModel]: [any, any] = useState({});
    const [promotionForTranslate, setPromotionForTranslate]: [any, any] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        const value = localStorage.getItem("UserConfigData");
        if (typeof value === 'string') {
            setUserConfigData(JSON.parse(value));
        }

        getPromotions();
        createPromotionTypeOptions();
    }, [])

    function createPromotionTypeOptions() {
        const options: any[] = [];
        for (var i = 3; i < 5; i++) {
            options.push({ label: getPromotiontypeDescription(i), value: i });
        }
        setPromotionTypeOptions(options);
    }

    function getPromotions() {
        setShowLoadingModal(true);
        API.get("AE", `/Offers`, { response: true })
            .then(res => {
                let data = res.data.length ? res.data.filter(el => el.IsChallengeSpendingPromotion === true) : res.data;
                setData(data);
                if (data.length) {
                    renderData(data);
                }
            })
            .catch(error => {
                console.log(error);
                setToastType("error");
                setToastMessage(t('promotionscarttable.error.getting-promotions'));
                setShowToastMessage(true);
            })
    }

    async function renderData(data) { // corresponds with List<OfferDto>

        const promotionsRender: any[] = [];

        data.forEach(p => {
            // Datetime objects
            let startDate = new Date(p.StartDate);
            let endDate = new Date(p.EndDate);
            let currDate = new Date();

            let promotionTimeFrame = "";
            if (currDate < startDate) { promotionTimeFrame = "Toekomst"; }
            if (currDate >= startDate && currDate < endDate) { promotionTimeFrame = "Huidige" }

            // Display dates
            let displayStartDate = p.StartDate.split("T")[0];
            displayStartDate = displayStartDate.split("-");
            displayStartDate = `${displayStartDate[2]}/${displayStartDate[1]}/${displayStartDate[0]}`

            let displayEndDate = p.EndDate.split("T")[0];
            displayEndDate = displayEndDate.split("-");
            displayEndDate = `${displayEndDate[2]}/${displayEndDate[1]}/${displayEndDate[0]}`

            let discountDescription = "";

            if (p.FixedDiscount > 0) {
                discountDescription = "€ " + p.FixedDiscount;
            } else if (p.Discount > 0) {
                discountDescription = p.Discount + " %";
            }

            promotionsRender.push({
                Id: p.Id,
                Title: p.Title,
                Description: p.Description,
                Avatar: p.Avatar ? p.Avatar : " ",
                StartDate: p.StartDate,
                EndDate: p.EndDate,
                DisplayStartDate: displayStartDate,
                DisplayEndDate: displayEndDate,
                IsChallengeSpendingPromotion: p.IsChallengeSpendingPromotion ? "Yes" : "No",
                FixedDiscount: p.FixedDiscount,
                PercentageDiscount: p.Discount,
                MinimumSpending: p.MinimumSpending,
                VisibilitySpendingThreshold: p.VisibilitySpendingThreshold,
                PromotionTimeFrame: promotionTimeFrame,
                DiscountDescription: discountDescription,
                IsBarcodeScanPromotion: p.IsBarcodeScanPromotion ? 'Yes' : 'No',
                MaximumNoOfUsages: p.MaximumNoOfUsages,
                NoOfUsages: p.NoOfUsages
            })
        });
        setShowFilteredData(false);
        setData(promotionsRender);
        setShowLoadingModal(false);
    }

    function getPromotiontype(percentageDiscount) {
        var promotionType;

        if (percentageDiscount > 0) {
            promotionType = 4;
        } else {
            promotionType = 3;
        }

        return promotionType;
    }

    function getPromotiontypeDescription(promotionType) {
        var description;

        switch (promotionType) {
            case 3:
                {
                    description = t('promotionscarttable.fixed-discount');
                    break;
                }
            case 4:
                {
                    description = t('promotionscarttable.percentual-discount');
                    break;
                }
            case 5:
                {
                    description = t('promotionscarttable.free-product'); // fase 2
                    break;
                }
            default:
                {
                    description = "";
                    break;
                }
        }

        return description;
    }

    async function createOrUpdatePromotion(reqBody: Promotion) {
        let path = '/Offers';
        let body: Promotion = reqBody
        if (reqBody.Id) { body.Id = reqBody.Id };
        let res;
        if (reqBody.Id) {
            res = await API.put('AE', path, { body });
        } else {
            res = await API.post('AE', path, { body });
        }
        return res;
    }

    async function deleteEntry() {
        let path = '/Offers';
        let myInit = {}
        try {
            setToastType("success");
            setToastMessage(t('promotionscarttable.promotion-deleted'));
            setShowToastMessage(true);
            return await API.del('AE', path + "?offerId=" + activeRow.original.Id, myInit);
        } catch (err) {
            console.log(err);
            setToastType("error");
            setToastMessage(t('promotionscarttable.error.deleting-category'));
            setShowToastMessage(true);
            return null;
        }
    }

    const columns = React.useMemo(
        () => [
            {
                Header: t('promotionscarttable.name'),
                accessor: 'Title',
                hide: false,
            },
            {
                Header: t('promotionscarttable.description'),
                accessor: 'Description',
                hide: true,
            },
            {
                Header: t('promotionscarttable.avatar'),
                accessor: 'Avatar',
                hide: true,
            },
            {
                Header: 'StartDate',
                accessor: 'StartDate',
                hide: true,
            },
            {
                Header: 'EndDate',
                accessor: 'EndDate',
                hide: true,
            },
            {
                Header: t('promotionscarttable.startdate'),
                accessor: 'DisplayStartDate',
                hide: false,
            },
            {
                Header: t('promotionscarttable.enddate'),
                accessor: 'DisplayEndDate',
                hide: false,
            },
            {
                Header: t('promotionscarttable.promotional-period'),
                accessor: 'PromotionTimeFrame',
                hide: false,
            },
            {
                Header: t('promotionscarttable.discount'),
                accessor: 'DiscountDescription',
                hide: false,
            },
            {
                Header: t('promotionscarttable.minimum-amount'),
                accessor: 'MinimumSpending',
                hide: false,
            },
            {
                Header: t('promotionscarttable.show-from-amount'),
                accessor: 'VisibilitySpendingThreshold',
                hide: false,
            },
            {
                Header: t('promotionscarttable.qr-code'),
                accessor: 'Id',
                hide: true,
            },
            {
                Header: t('promotionscarttable.qr-code-promotion'),
                accessor: 'IsBarcodeScanPromotion',
                hide: true,
            },
            {
                Header: t('promotionscarttable.max-attempt'),
                accessor: 'MaximumNoOfUsages',
                hide: true,
            },
            {
                Header: t('promotionscarttable.used'),
                accessor: 'NoOfUsages',
                hide: true,
            },
        ],
        []
    );

    function prepTranslation(row) {
        setShowLoadingModal(true);
        API.get("AE", `/Translations/GetOfferTranslations?offerId=${row.values.Id}`, { response: true })
            .then(res => {
                let data = res.data;
                let fields = [{ name: 'LanguageCode', input: false }, { name: 'Title', input: true }];
                setTranslationFormModel(data);
                setTranslationFormFieldsModel(fields);
                setPromotionForTranslate(row.values);
                setShowTranslationModal(true);
            })
            .catch(error => {
                console.log(error);
                setToastType("error");
                setToastMessage(t('promotionscarttable.error.getting-translations'));
                setShowToastMessage(true);
            })
            .finally(() => {
                setShowLoadingModal(false);
            })
    }

    async function prepForm(row) {

        const rowValues = row !== null ? row.original : null;
        const addingRow = rowValues === null;

        const _formValues = {
            Id: addingRow ? 0 : rowValues.Id,
            Title: addingRow ? "" : rowValues.Title,
            Description: addingRow ? "" : rowValues.Description,
            StartDate: addingRow ? new Date() : rowValues.StartDate,
            EndDate: addingRow ? new Date() : rowValues.EndDate,
            IsChallengeSpendingPromotion: addingRow ? true : rowValues.IsChallengeSpendingPromotion === "Yes" ? true : false,
            FixedDiscount: addingRow ? 0 : rowValues.FixedDiscount,
            PercentageDiscount: addingRow ? 0 : rowValues.PercentageDiscount,
            MinimumSpending: addingRow ? 0 : rowValues.MinimumSpending,
            VisibilitySpendingThreshold: addingRow ? 0 : rowValues.VisibilitySpendingThreshold,
            Avatar: addingRow ? "" : rowValues.Avatar,
            PromotionTypeId: addingRow ? 3 : getPromotiontype(rowValues.PercentageDiscount),
            IsBarcodeScanPromotion: addingRow ? false : rowValues.IsBarcodeScanPromotion === "Yes" ? true : false,
            MaximumNoOfUsages: addingRow ? 0 : rowValues.MaximumNoOfUsages
        };

        const formObj = [
            {
                name: "PromotionTypeId",
                type: "select",
                label: t('promotionscarttable.promotion-type'),
                required: true,
                initialValue: _formValues.PromotionTypeId,
                options: PromotionTypeOptions
            },
            {
                name: "Title",
                type: "text",
                label: t('promotionscarttable.name'),
                required: true,
                initialValue: _formValues.Title
            },
            {
                name: "Description",
                type: "text",
                label: t('promotionscarttable.description'),
                initialValue: _formValues.Description
            },
            {
                name: "MinimumSpending",
                type: "number",
                label: t('promotionscarttable.minimum-amount'),
                initialValue: _formValues.MinimumSpending
            },
            {
                name: "VisibilitySpendingThreshold",
                type: "number",
                label: t('promotionscarttable.show-from-amount'),
                initialValue: _formValues.VisibilitySpendingThreshold
            },
            {
                name: "FixedDiscount",
                type: "number",
                label: t('promotionscarttable.fixed-discount-amount'),
                initialValue: _formValues.FixedDiscount
            },
            {
                name: "PercentageDiscount",
                type: "number",
                label: t('promotionscarttable.percentual-discount'),
                initialValue: _formValues.PercentageDiscount
            },
            {
                name: "StartDate",
                type: "date",
                label: t('promotionscarttable.startdate'),
                initialValue: _formValues.StartDate
            },
            {
                name: "EndDate",
                type: "date",
                label: t('promotionscarttable.enddate'),
                initialValue: _formValues.EndDate
            },
            {
                name: "Avatar",
                type: "file",
                label: t('generic.select'),
                objUrl: addingRow ? "" : rowValues.Avatar.trim() ? UserConfigData.Customer + '/images/promotions/pid' + rowValues.Id + "_" + rowValues.Avatar : "",
                maxHeight: 320,
                maxWidth: 320
            },
        ];

        const enrichedFormObj = enrichFeatureFilteredColumnsForForm(formObj, _formValues, addingRow, rowValues);

        setFormObj(enrichedFormObj);
        setActiveRow(rowValues);
        setFormMode(rowValues === null ? "Add" : "Edit");
        setFormValues(_formValues);
        setShowForm(true);
    }

    async function submit(values) {
        values.IsCombination = false;

        // replace '' with 0 for number values to avoid parsing errors in the controller
        values.Product1Id = " ";
        values.Product2Id = " ";
        values.MinimumSpending = getZeroOnEmpty(values.MinimumSpending);
        values.VisibilitySpendingThreshold = getZeroOnEmpty(values.VisibilitySpendingThreshold);
        values.FixedDiscount = getZeroOnEmpty(values.FixedDiscount);
        values.PercentageDiscount = getZeroOnEmpty(values.PercentageDiscount);
        values.OfferSameProductUnits = getZeroOnEmpty(values.OfferSameProductUnits);
        values.ProductDiscount = getZeroOnEmpty(values.ProductDiscount);
        values.ProductFixedPrice = getZeroOnEmpty(values.ProductFixedPrice);
        values.MaximumNoOfUsages = getZeroOnEmpty(values.MaximumNoOfUsages);

        let validationResult = validateForm(values);

        if (validationResult.valid) {
            setShowLoadingModal(true);
            const reqBody = promotionsFormToReqBody(activeRow, values);

            setShowForm(false);
            const res = await createOrUpdatePromotion(reqBody);
            if (res) {
                setToastType("success");
                //setToastMessage(`Promotion ${activeRow === null ? "added" : "edited"} successfully!`);
                setToastMessage(
                t('promotionscarttable.edit-success', {
                    product: t('promotionscarttable.promotion'),
                    action: activeRow === null ? t('generic.added') : t('generic.edited')
                })
                );
                setShowToastMessage(true);
                getPromotions();
            } else {
                setToastType("error");
                //setToastMessage(`Error ${activeRow === null ? "adding" : "editing"} Promotion`);
                setToastMessage(
                t('promotionscarttable.edit-fail', {
                    error: t('generic.error'),
                    action: activeRow === null ? t('generic.adding') : t('generic.editing'),
                    product: t('promotionscarttable.promotion')
                })
                );
                setShowToastMessage(true);
            }

            let putResp;
            let imageChange;

            if (activeRow) {
                if (values.Avatar !== activeRow.Avatar) {
                    imageChange = true;
                    putResp = await s3put(`${UserConfigData.Customer}/images/promotions/pid${res.Id}_${reqBody.Avatar}`, values.Avatar);
                }
            } else {
                imageChange = true;
                putResp = await s3put(`${UserConfigData.Customer}/images/promotions/pid${res.Id}_${reqBody.Avatar}`, values.Avatar);
            }

            if (!putResp && imageChange) {
                setToastType("error");
                setToastMessage(t('promotionscarttable.error.upload-failed'));
                setShowToastMessage(true);
            }

            setShowLoadingModal(false);
        } else {
            setToastType("error");
            setToastMessage(validationResult.message);
            setShowToastMessage(true);
        }
    }

    function validateForm(values) {
        var result = {
            valid: false,
            message: ''
        }

        // VALIDATIONS
        if (values.MinimumSpending <= 0) {
            result.message = t('promotionscarttable.error.minimum-amount')
            return result;
        }

        if (values.IsBarcodeScanPromotion) {
            if (values.VisibilitySpendingThreshold != 0) {
                result.message = t("promotionscarttable.error.info-is-qrcode")
                return result;
            }
        }
        else {
            if (values.VisibilitySpendingThreshold <= 0) {
                result.message = t('promotionscarttable.error.show-amount-obligated')
                return result;
            }
            if (values.VisibilitySpendingThreshold >= values.MinimumSpending) {
                result.message = t('promotionscarttable.error.min-amount-too-small')
                return result;
            }
        }

        if (values.PromotionTypeId === 3) {
            // static discount
            if (values.FixedDiscount <= 0) {
                result.message = t('promotionscarttable.error.fixed-discount-obligated');
                return result;
            }

            if (values.FixedDiscount > values.MinimumSpending) {
                result.message = t('promotionscarttable.error.fixed-discount-too-high');
                return result;
            }
        }

        if (values.PromotionTypeId === 4) {
            // percentage discount
            if (values.PercentageDiscount <= 0) {
                result.message = t('promotionscarttable.error.percentual-discount-obligated');
                return result;
            }

            if (values.PercentageDiscount > 100) {
                result.message = t('promotionscarttable.error.percentual-discount-too-big');
                return result;
            }
        }
        // check if a promotion for the product exists
        if (values.PromotionTypeId === 3) {
            if (values.PercentageDiscount > 0) {
                result.message = t('promotionscarttable.error.no-percentual-discount');
                return result;
            }
        }

        if (values.PromotionTypeId === 4) {
            if (values.FixedDiscount > 0) {
                result.message = t('promotionscarttable.error.no-fixed-discount-amount');
                return result;
            }
        }

        if (new Date(values.StartDate) >= new Date(values.EndDate)) {
            result.message = t('promotionscarttable.error.enddate-not-greater-than-startdate');
            return result;
        }

        if (!values.Avatar || values.Avatar === " ") {
            result.message = t('promotionscarttable.error.promotion-image-obligated');
            return result;
        }

        result.valid = true;

        return result;
    }

    async function submitTranslationValue(rows) {
        let path = `/Translations/AddOrUpdateOfferTranslations?OfferId=${promotionForTranslate.Id}`;
        let body = rows;
        await API.post('AE', path, { body });
        setShowTranslationModal(false);
        setToastType("success");
        setToastMessage(t('promotionscarttable.translation-saved'));
        setShowToastMessage(true);
    }

    function handleDeleteConfirmation(row) {
        setActiveRow(row);
        setShowConfirmationModal(true);
    }

    async function confirmDelete() {
        setShowLoadingModal(true);
        setShowConfirmationModal(false);
        const deleted = await deleteEntry();
        if (deleted) {
            if (activeRow.original.Avatar.trim()) {
                const filePath = `${UserConfigData.Customer}/images/promotions/pid${activeRow.original.Id}_${activeRow.original.Avatar}`
                const res = await s3remove(filePath);
                if (!res) {
                    setToastType("error");
                    setToastMessage(t('promotionscarttable.error.image-delete-failed'));
                    setShowToastMessage(true);
                }
            }
        }
        getPromotions();
    }

    function filterPromotions(timeFrame: "all" | "current" | "future", mode: "discount") {
        let filteredData;
        let currDate = new Date();
        filteredData = data.filter(el => el.IsChallengeSpendingPromotion === "Yes");

        if (timeFrame === "current") {
            filteredData = filteredData.filter(el => currDate >= new Date(el.StartDate) && currDate < new Date(el.EndDate));
        }
        if (timeFrame === "future") {
            filteredData = filteredData.filter(el => new Date(el.StartDate) > currDate);
        }

        setFilteredData(filteredData)
        setShowFilteredData(true);
    }

    // FEATURE Specific functions
    function getFeatureFilteredColumns() {
        if (UserConfigData && UserConfigData.EnabledFeatures) {
            if (UserConfigData.EnabledFeatures.includes('barcodescanpromotion')) {
                // unhide columns for barcodescan feature (IsBarcodeScanPromotion, MaximumNoOfUsages, NoOfUsages)
                return columns.map(column => ["IsBarcodeScanPromotion", "MaximumNoOfUsages", "NoOfUsages"].includes(column.accessor) ? ({ ...column, hide: false }) : ({ ...column }));
            }
        }
        return columns;
    }

    function enrichFeatureFilteredColumnsForForm(formObj, formValues, addingRow, rowValues) {
        const formObjResponse = formObj;

        if (UserConfigData && UserConfigData.EnabledFeatures) {
            if (UserConfigData.EnabledFeatures.includes('barcodescanpromotion')) {
                if (rowValues && rowValues.IsBarcodeScanPromotion === 'Yes') {
                    formObjResponse.push({
                        name: "Id",
                        type: "qrcode",
                        label: "Id",
                        initialValue: formValues.Id
                    });
                }
                formObjResponse.push({
                    name: "IsBarcodeScanPromotion",
                    type: "checkbox",
                    label: t('promotionscarttable.question-is-qrcode'),
                    checked: addingRow ? false : rowValues.IsBarcodeScanPromotion === 'Yes' ? true : false
                })

                if (rowValues && rowValues.IsBarcodeScanPromotion === 'Yes') {
                    formObjResponse.push({
                        name: "MaximumNoOfUsages",
                        type: "number",
                        label: t('promotionscarttable.max-qrcode-amount'),
                        checked: addingRow ? 0 : rowValues.MaximumNoOfUsages
                    });
                }
                return formObjResponse;
            }
        }
        return formObjResponse;
    }

    return (
        <div>
            <h2 className="mb-05">{t('promotionscarttable.promotions-spend-amount')}</h2>
            <div className="table-filters">
                <label>Filters: </label>
                <button onClick={() => { filterPromotions("all", "discount") }}>{t('promotionscarttable.show-all')}</button>
                <button onClick={() => { filterPromotions("current", "discount") }}>{t('promotionscarttable.current-discount-deals')}</button>
                <button onClick={() => { filterPromotions("future", "discount") }}>{t('promotionscarttable.future-discount-deals')}</button>
            </div>
            <CssBaseline />
            {UserConfigData.Customer ?
                <DynamicTable
                    addRow={() => prepForm(null)}
                    editRow={(row) => prepForm(row)}
                    editRowTranslation={(row) => prepTranslation(row)}
                    deleteRow={(row) => handleDeleteConfirmation(row)}
                    columns={getFeatureFilteredColumns()}
                    data={ShowFilteredData ? filteredData : data}
                    //data={filteredData}
                    loading={false}
                    className="Promotions"
                />
                : null
            }
            {
                showForm ?
                    <DForm
                        formObj={formObj}
                        formMode={formMode}
                        initialValues={formValues}
                        qrcodeType={'challengespendingpromotion_'}
                        closeModal={() => setShowForm(false)}
                        submit={submit}
                    />
                    : null
            }
            {
                showTranslationModal ?
                    <PromotionTranslationModal
                        rows={translationFormModel}
                        fields={translationFormFieldsModel}
                        promotion={promotionForTranslate}
                        closeModal={() => setShowTranslationModal(false)}
                        save={submitTranslationValue}
                    />
                    : null
            }
            {showConfirmationModal ?
                <ConfirmationModal
                    message={t('promotionscarttable.question-delete-promotion')}
                    confirm={confirmDelete}
                    closeModal={() => setShowConfirmationModal(false)}
                />
                : null}
            <div className="mt1" />
        </div>
    )
}

export default PromotionsCartTable;
